import BREAKPOINTS from '@lib/constants/breakpoints';
import { useAmp } from 'next/amp';
import React from 'react';
import styled from 'styled-components';

const Header = styled.header`
  position: relative;
  padding: 124px 64px 32px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    padding: 82px 32px 32px;
    text-align: center;
  }
`;

const BasicHeader = React.forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement>
>((props, ref) => {
  const amp = useAmp();

  return <Header {...props} style={{ paddingTop: amp ? 32 : undefined }} ref={ref} />;
});

export default BasicHeader;
